import { DatePicker } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button as AntButton } from "antd";

const DateFilter = ({
  actionDateFilter,
  handleDateRangeFilter,
  handleClickChangeDate,
  solutionDateFilter,
}) => {
  const { t } = useTranslation(["orderStatistic"]);

  const onChangeDatePicker = (value, mode) => {
    if (value && value.length) {
      handleDateRangeFilter({ startDate: value[0], endDate: value[1] }, mode);
    }
  };

  return (
    <div className="filter-runner-date-group">
      <div className="filter-runner-date d-flex flex-row justify-content-start align-items-center gap-2">
        <AntButton
          type={actionDateFilter.active ? "primary" : "default"}
          ghost={actionDateFilter.active}
          onClick={() => handleClickChangeDate("action-date")}
          className="ant-btn-custom"
        >
          {t("form.action_date")}:
        </AntButton>
        <DatePicker.RangePicker
          onChange={value => onChangeDatePicker(value, "action-date")}
          value={[actionDateFilter.startDate, actionDateFilter.endDate]}
          allowClear={false}
        />
      </div>
      <div className="filter-runner-date d-flex flex-row justify-content-start align-items-center gap-2">
        <AntButton
          type={solutionDateFilter.active ? "primary" : "default"}
          ghost={solutionDateFilter.active}
          onClick={() => handleClickChangeDate("solution-date")}
          className="ant-btn-custom"
        >
          {t("form.solution_date")}:
        </AntButton>
        <DatePicker.RangePicker
          onChange={value => onChangeDatePicker(value, "solution-date")}
          value={[solutionDateFilter.startDate, solutionDateFilter.endDate]}
          allowClear={false}
        />
      </div>
    </div>
  );
};

export default DateFilter;
